<form [formGroup]="form" (ngSubmit)="save()">
    <h1 mat-dialog-title>Control de orden</h1>
    <div mat-dialog-content>
        <mat-form-field class="full-control">
            <input type="text" matInput placeholder="Protocolo" formControlName="Protocol" required>
        </mat-form-field>
    </div>
    <div class="clearfix">
        <div class="pull-right">
            <mat-spinner *ngIf="loading" [diameter]="20"></mat-spinner>
            <button *ngIf="!loading" mat-button type="submit">Aceptar</button>
            <button *ngIf="!loading" mat-button type="button" (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</form>